import React, { createContext, useContext, useMemo } from 'react';
import { defaultTheme } from './defaultTheme';

const ThemeContext = createContext(defaultTheme);

function applyThemeToCssVars(theme) {
  const root = document.documentElement;
  if (!root) return;

  const colors = theme?.colors ?? {};
  const typography = theme?.typography ?? {};

  if (colors.text) root.style.setProperty('--color-text', colors.text);
  if (colors.background) root.style.setProperty('--color-bg', colors.background);
  if (colors.primary) root.style.setProperty('--color-primary', colors.primary);
  if (colors.accent) root.style.setProperty('--color-accent', colors.accent);
  if (colors.border) root.style.setProperty('--color-border', colors.border);

  if (typography.fontBase) root.style.setProperty('--font-base', typography.fontBase);
  if (typography.fontDisplay) root.style.setProperty('--font-display', typography.fontDisplay);
}

export function ThemeProvider({ theme = defaultTheme, children }) {
  const merged = useMemo(() => {
    return {
      ...defaultTheme,
      ...theme,
      colors: { ...defaultTheme.colors, ...(theme?.colors ?? {}) },
      typography: { ...defaultTheme.typography, ...(theme?.typography ?? {}) },
    };
  }, [theme]);

  // Apply runtime CSS variables (multi-tenant support)
  applyThemeToCssVars(merged);

  return <ThemeContext.Provider value={merged}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}

